export default "__VITE_ASSET__Bf54hC3O__"